import './index.scss';
import LogoS from '../../../assets/images/jp.svg'

const Logo = () => {
    return (
        <div className='logo-container'>
            <img className='solid-logo' src={LogoS} alt="logo"/>
        </div>
    )
}
export default Logo;